import * as Sentry from '@sentry/react';

// Reload when a lazy-loaded chunk 404s (stale page after a new deploy)
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
});
